
export class OperationReworkModel {
    operationId: string;
    operationDesc: string;
    totalRework: number; // total times the rework flag is there in the hanger_routing
    totalSpentReworkSecs: number; // total sum of time time of the rework spent -- not required for external systems
    hour: number;
    operatorName: string;// refferd by external application
    operatorId?: string; // refferd by external application
    goodQuantity?: number; // refferd by external application

    constructor( operationId: string,
        operationDesc: string,
        totalRework: number,
        totalSpentReworkSecs: number,
        hour: number,
        operatorName: string,
        operatorId: string,
        goodQuantity: number
        ) {
            this.operationId = operationId;
            this.operationDesc = operationDesc;
            this.totalRework = totalRework;
            this.totalSpentReworkSecs = totalSpentReworkSecs;
            this.hour = hour;
            this.operatorName = operatorName;
            this.operatorId = operatorId;
            this.goodQuantity = goodQuantity;
    }
}

